import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/data-grid/components/columns-panel/columns-panel.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
